/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGenderThird = createReactComponent("gender-third", "IconGenderThird", [
  ["path", { d: "M11 12a5 5 0 1 0 10 0a5 5 0 0 0 -10 0z", key: "svg-0" }],
  ["path", { d: "M11 12h-3", key: "svg-1" }],
  ["path", { d: "M8 12l-5 -4v8z", key: "svg-2" }]
]);

export { IconGenderThird as default };
//# sourceMappingURL=IconGenderThird.js.map
